import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewCollections from "../Components/Collections Resale/viewCollections";
import ListCollections from "../Components/Collections Resale/listCollections";
import AddCollections from "../Components/Collections Resale/addCollections";
import AddSubCollections from "../Components/Collections Resale/addSubCollections";
import EditSubCollections from "../Components/Collections Resale/editSubCollections";
import EditCollections from "../Components/Collections Resale/editCollections";

const CollectionResaleRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route
        path="/collections_resale"
        element={<ListCollections></ListCollections>}
      />

      <Route
        path="/collections_resale/add"
        element={canAdd ? <AddCollections></AddCollections> : <Navigate to="/collections" replace />}
      />

      <Route
        path="/collections_resale/edit/:id"
        element={canEdit ? <EditCollections></EditCollections> : <Navigate to="/collections" replace />}
      />

      <Route
        path="/collections_resale/view/:id"
        element={<ViewCollections></ViewCollections>}
      ></Route>

      <Route
        path="/collections_resale/:id/sub/add"
        element={<AddSubCollections></AddSubCollections>}
      ></Route>

      <Route
        path="/collections_resale/:id/sub/edit"
        element={<EditSubCollections></EditSubCollections>}
      ></Route>
    </Routes>
  );
};

export default CollectionResaleRoutes;
